<template>
    <div class="mt-3">
        <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-3 cursor-pointer px-3" @click="openPret = !openPret">
            <h2 class="text-white text-lg">Prêts</h2>
            <span class="text-sm text-white">
                <font-awesome-icon v-if="openPret" :icon="['fa', 'chevron-down']" />
                <font-awesome-icon v-else :icon="['fa', 'chevron-right']" />
            </span>
        </div>

        <div class="overflow-x-auto" v-if="openPret">
            <div v-if="paginator && paginator.results && paginator.results.length !== 0" class="my-3 px-2">
                <div class="flex justify-between items-center mb-1">
                    <span class="text-sm text-gray-600 dark:text-gray-300">Progression globale</span>
                    <span class="text-xs text-gray-500">{{ globalProgress.toFixed(0) }} %</span>
                </div>
                <div class="w-full bg-gray-200 rounded-full h-2.5">
                    <div class="bg-indigo-600 h-2.5 rounded-full" :style="{width: globalProgress + '%'}"></div>
                </div>
                <div class="text-xs text-gray-500 mt-1">
                    <span v-if="globalProgress < 100">{{totalElapsedAmount.toLocaleString('fr-FR')}} € remboursés sur {{totalAmount.toLocaleString('fr-FR')}}  €</span>
                    <span v-else>{{ totalAmount }} € au total</span>
                </div>
            </div>
            <table class="w-full border-t-2 border-gray-600">
                <thead>
                    <tr class="">
                        <th scope="col" class="text-left py-3 px-2 text-sm font-normal rtl:text-right text-gray-500 dark:text-gray-400">
                            Montant total
                        </th>
                        <th scope="col" class="text-left py-3 px-2 text-sm font-normal rtl:text-right text-gray-500 dark:text-gray-400">
                            Mensualité
                        </th>
                        <th scope="col" class="text-left py-3 px-2 text-sm font-normal rtl:text-right text-gray-500 dark:text-gray-400">
                            Début
                        </th>
                        <th scope="col" class="text-left py-3 px-2 text-sm font-normal rtl:text-right text-gray-500 dark:text-gray-400">
                            Fin
                        </th>
                        <th scope="col" class="text-left py-3 px-2 text-sm font-normal rtl:text-right text-gray-500 dark:text-gray-400">
                            Progression
                        </th>
                        <th scope="col" class="text-left py-3.5 px-2 flex justify-end items-center">
                            <button class="btn btn-primary" @click="addNewPret = true">
                                <font-awesome-icon class="text-md" :icon="['fa', 'plus']" />
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="addNewPret"
                        class="border-t border-indigo-300"
                    >
                        <td class="px-2 py-3 text-sm font-medium whitespace-nowrap text-gray-400 dark:text-gray-500">
                            {{computedAmount.toLocaleString('fr-FR')}}€
                        </td>
                        <td class="px-2 py-3 text-sm font-medium whitespace-nowrap text-gray-700 dark:text-gray-300">
                            <AppInput
                                v-model='form.mensualite'
                                id='mensualite'
                                :validations="['number', 'required']"
                                @hasError="handleFormError"
                                :check-on-create="false"
                                :check-on-unfocus="true"
                                icon="euro-sign"
                            />
                        </td>
                        <td class="px-2 py-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                            <DatePicker
                                v-model='form.dateDebut'
                                id='dateDebut'
                                minimum-type="month"
                                maximum-type="month"
                            />
                        </td>
                        <td class="px-2 py-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                            <DatePicker
                                v-model='form.dateFin'
                                id='dateFin'
                                minimum-type="month"
                                maximum-type="month"
                                align="right"
                            />
                        </td>
                        <td class="px-2 py-3 text-sm font-medium text-gray-700 dark:text-gray-300"></td>
                        <td class="px-2 py-3 text-sm whitespace-nowrap">
                            <div class="flex justify-end items-center">
                                <button class="btn-secondary mr-1" @click="addNewPret = false">
                                    <font-awesome-icon class="text-sm" :icon="['fa', 'undo']" />
                                </button>
                                <button class="btn-success" :class="checkFieldValid ? '' : 'cursor-not-allowed bg-emerald-300 border-emerald-300 hover:bg-emerald-300 hover:border-emerald-300'" @click="addPret()">
                                    <font-awesome-icon v-if="addLoader" class="text-sm animate-spin" :icon="['fas', 'spinner']"  />
                                    <font-awesome-icon v-else class="text-sm" :icon="['fa', 'check']" />
                                </button>
                            </div>
                        </td>
                    </tr>
                    <template
                        v-if="paginator && paginator.results && paginator.results.length !== 0"
                    >
                        <template
                            v-for="pret of paginator.results" :key="pret.uuid"
                        >
                            <PretItem :pret="pret" @refresh="loadPret" />
                        </template>

                    </template>
                    <tr
                        class="px-2 py-3 border-t border-gray-200 dark:border-gray-800"
                        v-else-if="!loaded"
                    >
                        <td colspan="6">
                            <SpinnerLoader class="mt-5"></SpinnerLoader>
                        </td>
                    </tr>
                    <tr
                        class="px-2 py-3 border-t border-gray-200 dark:border-gray-800"
                        v-else-if="!addNewPret"
                    >
                        <td colspan="6" class="text-center">
                            <p class="text-sm text-indigo-400 my-4">Aucun prêt n'a été trouvé.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import SpinnerLoader from './../../../loader/SpinnerLoader';
import AppInput from './../../../form/AppInput';
import DatePicker from './../../../form/DatePicker';
import PretItem from './../../../bien/details/financials/PretItem';
import pretCalculator from './../../../../common/utils/PretCalculator';

export default {
    components: {
        SpinnerLoader,
        AppInput,
        DatePicker,
        PretItem
    },

    data() {
        return {
            paginator: {
                results: []
            },
            loaded: false,
            addNewPret: false,
            addLoader: false,
            form: {
                mensualite: null,
                dateDebut: null,
                dateFin: null
            },
            formInvalid: [],
            openPret: false,
        }
    },

    created() {
        this.loadPret()
    },

    computed: {
        checkFieldValid() {
            return this.formInvalid.length === 0 && this.form.mensualite && this.form.dateDebut && this.form.dateFin;
        },

        globalProgress() {
            return pretCalculator.globalProgress(this.paginator?.results ?? []);
        },

        totalAmount() {
            return pretCalculator.totalAmount(this.paginator?.results ?? []);
        },

        totalElapsedAmount() {
            return pretCalculator.totalElapsedAmount(this.paginator?.results ?? []);
        },

        computedAmount() {
            return (this.form.mensualite || 0) * pretCalculator.totalMonths({date_debut: this.form.dateDebut, date_fin: this.form.dateFin});
        }
    },

    methods: {
        async loadPret() {
            this.loaded = false

            this.paginator = await this.$api.bien.getPrets(1, this.$route.params.bienUuid);

            this.loaded = true
        },

        handleFormError(event) {
            if (event.value && !this.formInvalid.includes(event.name)) {
                this.formInvalid.push(event.name);
            }

            if (!event.value && this.formInvalid.includes(event.name)) {
                this.formInvalid = this.formInvalid.filter(f => f !== event.name)
            }
        },

        async addPret() {
            if (!this.checkFieldValid) {
                return;
            }

            this.addLoader = true

            await this.$api.bien.addPret(this.$route.params.bienUuid, {
                mensualite: this.form.mensualite,
                date_debut: this.form.dateDebut,
                date_fin: this.form.dateFin
            })
            .then(async () => {
                this.$toast({title: 'Succès', description: "Le prêt à bien été enregistré."}, this.$toastSuccess);
                this.form = {
                    mensualite: null,
                    dateDebut: null,
                    dateFin: null
                }
                await this.loadPret()
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.addNewPret = false
            this.addLoader = false
        },
    }
};
</script>
